/* eslint-disable react/no-danger */
import React, { FC } from 'react';
import PreviewItem from 'src/components/PreviewItem';
import useStyles from './Overview.styles';

const Overview: FC<OverviewDto> = ({
  PagesPreview,
  Orientation,
  BottomText,
}) => {
  const cls = useStyles();

  return (
    <>
      <div className={cls.root} data-orientation={Orientation}>
        {PagesPreview.map((p) => (
          <PreviewItem
            key={p.UID}
            title={p.Title}
            url={p.Url}
            UID={p.UID}
            previewImage={p.PreviewImage}
            role={p.Role}
            email={p.Email}
          />
        ))}
      </div>
      {BottomText && (
        <div
          className={cls.bottomText}
          dangerouslySetInnerHTML={{ __html: BottomText }}
        />
      )}
    </>
  );
};

export default Overview;
